import { Alert, List, ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ListDetailsPanel } from "source/components/framework/List/ListDetailsPanel";
import { ICalendarTaskItem } from "ui/Scripts/source/models/calendarTask/calendarTaskItem";
import { CalendarTaskState } from "ui/Scripts/source/models/enums";
import { CalendarTaskListItem, ICalendarTaskDayItem } from "./CalendarTaskListItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { getEventsByDate, getEventsByDay } from "./ICalendarTaskListUtils";

interface CalendarTaskListProps {
    startDate?: number;
    endDate?: number;
    events: ICalendarTaskItem[];
    onItemClick: (id: string) => void;
    onClose: () => void;
}

export const CalendarTaskList = (props: CalendarTaskListProps) => {
    const [eventsByDate, setEventsByDate] = useState<ICalendarTaskDayItem[]>([]);
    const [stateFilter, setStateFitler] = useState([CalendarTaskState.NotStarted, CalendarTaskState.Started]);

    useEffect(() => {
        const items = props.events.filter((item) => stateFilter.includes(item.state));
        const eventsByDay = getEventsByDay(items, props.startDate, props.endDate)
            .sort((a, b) => a.startDate - b.startDate);
        setEventsByDate(
            getEventsByDate(
                eventsByDay
            )
        );
    }, [props.events, stateFilter]);

    const handleFilterChange = (_event: React.MouseEvent<HTMLElement>, value: any) => {
        setStateFitler(value);
    };

    return (
        <ListDetailsPanel onClose={props.onClose}>
            <FormField title={Translations.CalendarTaskFilterByState} margin={"1rem"} fullWidth={false}>
                <ToggleButtonGroup color="primary" value={stateFilter} onChange={handleFilterChange}>
                    <ToggleButton value={CalendarTaskState.NotStarted}>
                        {Translations.CalendarTaskStateNotStarted}
                    </ToggleButton>
                    <ToggleButton value={CalendarTaskState.Started}>
                        {Translations.CalendarTaskStateStarted}
                    </ToggleButton>
                    <ToggleButton value={CalendarTaskState.Finished}>
                        {Translations.CalendarTaskStateFinished}
                    </ToggleButton>
                </ToggleButtonGroup>
            </FormField>
            <List
                sx={{
                    height: "calc(100vh - 238px)",
                    paddingTop: 0,
                    overflowY: "auto",
                }}
            >
                {eventsByDate?.map((item) => (
                    <CalendarTaskListItem
                        key={item.id}
                        item={item}
                        onOpen={props.onItemClick}
                    />
                ))}
                {eventsByDate?.length === 0 &&
                    <Alert severity="info">{Translations.CalendarTaskChangeSelectedDateToSeeTheTasks}</Alert>
                }
            </List>
        </ListDetailsPanel>
    );
};
